import "./style.scss";

const ProductLabels = ({ labels }) => {
  return labels.length > 0 ? (
    <div>
      <div className={"product-labels"}>
        {labels
          .filter(label => label.type !== "tech")
          .map((label, idx) => (
            <div key={idx}>
              <img title={label.name} alt={label.name} src={label.imagePath} />
            </div>
          ))}
      </div>
      <div className={"product-labels"}>
        {labels
          .filter(label => label.type === "tech")
          .map((label, idx) => (
            <div key={idx}>
              <img title={label.name} alt={label.name} src={label.imagePath} />
            </div>
          ))}
      </div>
    </div>
  ) : null;
};

export default ProductLabels;
